import { AlertConfigDetails } from './alertconfigdetails';
import { Filter } from '../jobs/filter';

export class JobAlertUI {
  public id: number = 0;
  public name: string = '';
  public email: string = '';
  public fullName: string = '';
  public companyCode: string = '';
  public alertConfigDetails: AlertConfigDetails = new AlertConfigDetails();
  public filter: Filter = new Filter();
  public status: number = 0;
  public isActive: boolean = false;
  public isValidated: boolean = false;
}
